import Vue from 'vue';
import Vuex from 'vuex';
import axios from "axios";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        step: 1,
        user: {
            email: '',
            plan: '',
        }
    },
    mutations: {
        SET_STEP(state, val) {
            state.step = val;
        },
        SET_EMAIL(state, email) {
            state.user.email = email;
        },

        SET_PLAN(state, plan) {
            state.user.plan = plan;
        }
    },
    actions: {
        createCRMContact: ({ state }, { data, callback }) => {
            axios({
                url: window.config.stargazerBaseUrl + "/v1/users/crm/createContact",
                method: "post",
                config: {
                    headers: {
                        'content-type': 'application/json',
                    },
                },
                data: data,
            })
                .then((res) => {
                    const contactId = res.data.body.contactId;
                    callback && callback(contactId);
                })
                .catch((err) => {
                    callback && callback();
                });
        },
        findCRMContactId: ({ state }, { data, callback }) => {
            axios({
                url: window.config.stargazerBaseUrl + "/v1/users/crm/findContactId",
                method: "post",
                config: {
                    headers: {
                        'content-type': 'application/json',
                    },
                },
                data: data,
            })
                .then((res) => {
                    const contactId = res.data.body.contactId;
                    callback && callback(contactId);
                })
                .catch((err) => {
                    callback && callback(err);
                });
        },
        updateCRMContact: ({state}, {data}) => {
            axios({
                url: window.config.stargazerBaseUrl + "/v1/users/crm/updateContact",
                method: "post",
                config: {
                    headers: {
                        'content-type': 'application/json',
                    },
                },
                data: data,
            })
        },
        sendSignupForm: ({ state }, { formData, callback }) => {
            axios({
                url: window.config.api,
                method: "post",
                config: {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                },
                data: formData,
            })
                .then(() => {
                    callback && callback();
                })
                .catch((err) => {
                    callback && callback(err.response.data.error);
                });
        }
    }
});